import { AdditionalSVGProps } from '@/models/Svg';

export const InstagramIcon = (
  props: React.SVGAttributes<SVGElement> & AdditionalSVGProps,
) => {
  const { className, fill = '#010f1d', ...rest } = props;

  return (
    <>
      <svg
        width='29'
        height='29'
        viewBox='0 0 29 29'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={className}
        {...rest}
      >
        <path
          d='M20.9609 1.58325H8.04427C4.47743 1.58325 1.58594 4.47475 1.58594 8.04159V20.9583C1.58594 24.5251 4.47743 27.4166 8.04427 27.4166H20.9609C24.5278 27.4166 27.4193 24.5251 27.4193 20.9583V8.04159C27.4193 4.47475 24.5278 1.58325 20.9609 1.58325Z'
          stroke={fill}
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M21.6056 7.39575H21.6185M19.6681 13.6862C19.8275 14.7612 19.6439 15.859 19.1434 16.8236C18.6428 17.7883 17.8509 18.5705 16.8802 19.0591C15.9095 19.5477 14.8094 19.7177 13.7365 19.5451C12.6635 19.3724 11.6724 18.8659 10.9039 18.0974C10.1355 17.329 9.6289 16.3378 9.45625 15.2649C9.2836 14.1919 9.45366 13.0919 9.94225 12.1212C10.4308 11.1504 11.2131 10.3585 12.1777 9.85798C13.1423 9.35746 14.2402 9.17385 15.3152 9.33325C16.4117 9.49585 17.4268 10.0068 18.2107 10.7906C18.9945 11.5745 19.5055 12.5896 19.6681 13.6862Z'
          stroke={fill}
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </>
  );
};
